import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles";
import { Colors, FONT_WEIGHT } from "../../helpers/theme";

const BaiscInfoStyle = makeStyles((theme) => ({
    root: {
      "& .socialbtn": {
        minWidth: "130px",
        minHeight: "48px",
        marginLeft: theme.spacing(3),
        //   marginTop: theme.spacing(6),
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
          marginLeft: theme.spacing(1),
        },
      },
      "& .MuiButton-containedSizeLarge": {
        minWidth: "130px",
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
        },
      },
    },
  }));

  const CaptureTypeStyle = makeStyles((theme) => ({
    root: {
      "& .socialbtn": {
        minWidth: "130px",
        minHeight: "48px",
        marginLeft: theme.spacing(3),
        //   marginTop: theme.spacing(6),
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
        },
      },
      "& .MuiButton-containedSizeLarge": {
        minWidth: "130px",
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
        },
      },
      "& .longbtn":{
        "& .MuiButtonBase-root ":{
          paddingLeft: "46px",
          paddingRight: "46px",
          [theme.breakpoints.down("xs")]: {
            minWidth: "100%",
          },
        }
      }
    },
  }));

  const KYCStyles = makeStyles((theme) => ({
    profilesetting: {
      margin: "40px 0 100px 0 ",
      [theme.breakpoints.down("xs")]: {
        margin: "24px 0 32px 0 ",
      },
      "& .MuiTypography-h2": {
        [theme.breakpoints.down("xs")]: {
          fontSize: "16px",
        },
      },
    },
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      "& .MuiTabs-root": {
        "& .MuiButtonBase-root": {
          marginRight: theme.spacing(3),
          [theme.breakpoints.down("xs")]: {
            marginRight: "12px",
          },
        },
      },
    },
  }));

  const VerificationDetailStyles = makeStyles((theme) => ({
    root: {
      "& .socialbtn": {
        minWidth: "130px",
        minHeight: "48px",
        marginLeft: theme.spacing(3),
        //   marginTop: theme.spacing(6),
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
        },
      },
      "& .MuiButton-containedSizeLarge": {
        minWidth: "130px",
        [theme.breakpoints.down("xs")]: {
          minWidth: "48%",
        },
      },
      "& .licensemobile":{
        [theme.breakpoints.down("xs")]: {
          width: '100%'
        },
        
      }
    },
  }));
  

  export {BaiscInfoStyle, CaptureTypeStyle, KYCStyles, VerificationDetailStyles  };